// extracted by mini-css-extract-plugin
module.exports = {"Progress__bar__bg":"Progress_Progress__bar__bg__3rtvA","Progress__bar__fg":"Progress_Progress__bar__fg__1o1Cu"};